import { Fill } from '#/api/fills';

export function isLiquidationFill(fill: Fill): boolean {
  return fill.fill_type === 'LIQUIDATION';
}
